// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Fg+Me","content":"styles_content__NBEjQ","sticky":"styles_sticky__Tsodc","stickyContent":"styles_stickyContent__P8nkj"};